import type { Negocio } from "./tipos";

/**
 * Datos de la ficha que conviene completar para trabajar el lead (propuesta v1.1 §2).
 * «Quién decide» se quitó del aviso el 01/10/2026 (Robert): solo teléfono, email y persona
 * de contacto.
 */
export type DatoQueFalta = "telefono" | "email" | "persona_contacto";

const vacio = (v?: string | null) => !v || v.trim() === "";

/**
 * Qué falta en la ficha: teléfono, email o persona de contacto. Función pura: la interfaz
 * solo lo muestra, nunca obliga a rellenar (decisión v1.1: en la calle, nada de ventanas
 * obligatorias).
 */
export const datosQueFaltan = (
  negocio: Pick<Negocio, "telefono" | "email" | "persona_contacto">,
): DatoQueFalta[] => {
  const faltan: DatoQueFalta[] = [];
  if (vacio(negocio.telefono)) faltan.push("telefono");
  if (vacio(negocio.email)) faltan.push("email");
  if (vacio(negocio.persona_contacto)) faltan.push("persona_contacto");
  return faltan;
};

type Traductor = (clave: string, opciones?: Record<string, unknown>) => string;

/** «Faltan datos: teléfono · email» o null si la ficha está completa (para avisos). */
export const textoDatosQueFaltan = (
  translate: Traductor,
  negocio: Parameters<typeof datosQueFaltan>[0],
): string | null => {
  const faltan = datosQueFaltan(negocio);
  if (!faltan.length) return null;
  return translate("nevora.completitud.faltan", {
    datos: faltan
      .map((d) => translate(`nevora.completitud.datos.${d}`))
      .join(" · "),
  });
};
